// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"74941edc","405":"d78841e2","453":"3a56264a"}[chunkId] + ".chunk.js";
};